import { isProduction } from "@libs/environment";
import { INavPreviewCol } from "@models/nav.interface";

interface IResourcesPreviewState {
  columns: INavPreviewCol[];
}

export const ResourcesPreviewState: IResourcesPreviewState = {
  columns: [
    {
      cards: [
        { 
          title: 'Learn.Nav.Blog',
          subtitle: 'Learn.Nav.Blog_subtitle',
          iconSrc: '/layout-images/header/resources-preview/newspapper.svg',
          href: '/blog',
        },
        {
          title: 'Resources.Nav.Developers.Title',
          subtitle: 'Resources.Nav.Developers.Subtitle',
          iconSrc: '/layout-images/header/resources-preview/user-settings.svg',
          href: isProduction() ? `https://developers.gofinans.com` : `https://docs-fintech.dev.scrij.com/`,
          newTab: true,
        },
        {
          title: 'Learn.Nav.CryptoStats',
          subtitle: 'Learn.Nav.CryptoStats_subtitle',
          iconSrc: '/layout-images/header/resources-preview/network.svg',
          href: '/buy-crypto',
        },
      ],
    },
  ],
};
